import { useState } from "react";
import "./About.scss";
import AboutSection from './AboutSection';
import Title from './Title';
import SkillContainer from './SkillContainer';
import Certificate from './Certificate'

export default function About() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const data = [
    {
      id: "1",
     
      title: <Title title={'About Me'} span={'About Me'} />,
      desc:<AboutSection/>
        
    },
    {
      id: "2",
      
      title: <Title title={'My Skills'} span={'My Skills'}/>,
      desc: <SkillContainer/> ,
        
    },
    {
      id: "3",
      
      title: <Title title={'Certification'} span={'Certification'}/>,
      desc: <Certificate/>
        ,
    },
  ];
    
  

  const handleClick = (way) => {
    way === "left"
      ? setCurrentSlide(currentSlide > 0 ? currentSlide - 1 : 2)
      : setCurrentSlide(currentSlide < data.length - 1 ? currentSlide + 1 : 0);
  };
  
  return (
    <div className="abouts" id="about">
      <div
        className="slider"
        style={{ transform: `translateX(-${currentSlide * 100}vw)` }}
      > {data.map((d) => (
        <div className="container">
            <div className="item">
           
        {d.title}
        {d.desc}
        </div>
        </div>))}
      </div>
      <img
        src="assets/arrow.png"
        className="arrow left"
        alt=""
        onClick={() => handleClick("left")}
      />
      <img
        src="assets/arrow.png"
        className="arrow right"
        alt=""
        onClick={() => handleClick()}
      />
    </div>
  );
}
